import {
  Avatar,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Textarea,
} from '@chakra-ui/react'
import { useForm } from 'react-hook-form'

import * as S from './styles'
import { ArrowForwardIcon } from '@chakra-ui/icons'
import { useRef, useState } from 'react'
import Loading from 'pages/components/Loading'
import AlertComponent from 'pages/components/AlertComponent'
import { apiCg, apiSameOrigin } from 'services/api'
import { countComments } from 'utils'
import { useRecaptcha } from 'utils/useRecaptcha'

const Container = ({ comments, postId }) => {
  const { isValid, reply, question } = useRecaptcha()

  const truncateString = (str, num) => {
    if (str.length > num) {
      return str.slice(0, num) + '...'
    }

    return str
  }

  const formRef = useRef()
  const [selectedComment, setSelectedComment] = useState()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)

  const handleSelectComment = (comment, index) => {
    setSelectedComment({ ...comment, index })

    formRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }

  const {
    register,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm()

  const onSubmit = async (data) => {
    setLoading(true)
    try {
      const payload = {
        data,
        action: selectedComment?.name ? 'replyToComment' : 'addComment',
        origin: window.location.href,
        postId,
      }

      if (selectedComment?.name) payload.commentIndex = selectedComment?.index

      await apiSameOrigin.post(`/comments`, payload)

      setSuccess(true)
      setError(false)

      window?.scrollTo(0, 0)
      reset()
      setTimeout(() => {
        setSuccess(false)
      }, 5000)
    } catch (error) {
      setError(true)
      setSuccess(false)
      setTimeout(() => {
        setError(false)
        setSuccess(false)
      }, 5000)
    } finally {
      setLoading(false)
    }
  }

  return (
    <S.Comments>
      <Loading isLoading={loading} />
      <AlertComponent
        show={success}
        title="Comentário Enviado"
        status="success"
        description="Obrigado por enviar seu comentário!"
      />

      <AlertComponent
        show={error}
        title="Oops"
        status="error"
        description="Houve um erro ao enviar, tente novamente mais tarde."
      />

      <h4>{comments ? countComments(comments) : '0'} Comentários</h4>
      {comments &&
        comments?.map(
          (comment, i) =>
            comment.status && (
              <S.Comment key={i}>
                <S.Box>
                  <Avatar size="md" name={comment?.name} />
                  <S.Right>
                    <S.Name>{truncateString(comment?.name, 20)}</S.Name>
                    <S.Menssage>{comment?.message}</S.Menssage>
                    <S.Actions>
                      <S.ActionsButtons
                        onClick={() => handleSelectComment(comment, i)}
                      >
                        <svg
                          width="14"
                          height="12"
                          viewBox="0 0 14 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.49366 1.21296C5.51575 1.20128 5.53993 1.19646 5.56398 1.19894C5.58803 1.20141 5.61117 1.2111 5.63128 1.22712C5.6514 1.24313 5.66783 1.26496 5.67908 1.29059C5.69033 1.31622 5.69603 1.34483 5.69566 1.3738V2.75778C5.69566 2.91696 5.74834 3.06961 5.84211 3.18216C5.93588 3.29472 6.06306 3.35795 6.19566 3.35795C6.86266 3.35795 8.20866 3.36395 9.49566 4.34462C10.4797 5.09363 11.4857 6.4572 12.0907 8.99711C11.0707 7.81718 9.90566 7.1774 8.88566 6.83771C8.25871 6.62986 7.61439 6.50666 6.96466 6.47041C6.69871 6.45639 6.43233 6.45959 6.16666 6.48001H6.15366L6.14866 6.48121L6.19566 7.07898L6.14566 6.48121C6.02225 6.4961 5.90785 6.56552 5.82468 6.67599C5.74152 6.78646 5.69554 6.93009 5.69566 7.07898V8.46296C5.69566 8.59259 5.58566 8.67422 5.49366 8.6238L1.50966 5.10323C1.49614 5.09119 1.48212 5.07997 1.46766 5.06962C1.44592 5.05394 1.42793 5.03177 1.41544 5.00526C1.40295 4.97876 1.39638 4.94883 1.39638 4.91838C1.39638 4.88793 1.40295 4.858 1.41544 4.83149C1.42793 4.80499 1.44592 4.78282 1.46766 4.76714C1.48213 4.75679 1.49615 4.74558 1.50966 4.73353L5.49366 1.21296ZM6.69566 7.66234C6.76366 7.66234 6.83866 7.66594 6.91866 7.66954C7.35266 7.69355 7.95266 7.77277 8.61866 7.99483C9.94466 8.43655 11.5147 9.43763 12.5587 11.6918C12.6151 11.8135 12.7051 11.9079 12.8131 11.9587C12.9212 12.0095 13.0406 12.0136 13.1508 11.9703C13.2611 11.927 13.3555 11.839 13.4176 11.7214C13.4798 11.6039 13.506 11.464 13.4917 11.3257C13.0277 6.87252 11.6057 4.52947 10.0317 3.33154C8.78666 2.38328 7.50466 2.20083 6.69566 2.16602V1.3738C6.69576 1.12661 6.64026 0.883982 6.53503 0.671504C6.42981 0.459025 6.27875 0.284581 6.0978 0.166577C5.91685 0.0485736 5.71271 -0.00861364 5.50694 0.00104998C5.30117 0.0107136 5.10138 0.0868696 4.92866 0.221482L0.934665 3.75046C0.769545 3.87417 0.633371 4.0463 0.538963 4.25062C0.444555 4.45494 0.39502 4.68474 0.39502 4.91838C0.39502 5.15202 0.444555 5.38182 0.538963 5.58614C0.633371 5.79046 0.769545 5.96258 0.934665 6.0863L4.92866 9.61528C5.10138 9.74989 5.30117 9.82604 5.50694 9.83571C5.71271 9.84537 5.91685 9.78818 6.0978 9.67018C6.27875 9.55218 6.42981 9.37773 6.53503 9.16526C6.64026 8.95278 6.69576 8.71014 6.69566 8.46296V7.66234Z"
                            fill="#4B5563"
                          />
                        </svg>
                        Responder
                      </S.ActionsButtons>
                    </S.Actions>
                  </S.Right>
                </S.Box>

                {comment.replies && (
                  <S.SubComments>
                    {comment.replies.map((item, subIndex) => (
                      <S.Box key={`sub-item-${i}-${subIndex}`}>
                        <Avatar size="lg" name={item.name} />
                        <S.Right>
                          <S.Name>{truncateString(item.name, 20)}</S.Name>
                          <S.Menssage>{item.message}</S.Menssage>
                        </S.Right>
                      </S.Box>
                    ))}
                  </S.SubComments>
                )}
              </S.Comment>
            )
        )}

      <S.Form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
        <h4>Deixe uma resposta</h4>

        {selectedComment?.name && (
          <S.CommentBox>
            <h5>Responder para: {selectedComment?.name}</h5>
            <p>Mensagem: {selectedComment?.message}</p>
          </S.CommentBox>
        )}

        <FormControl isInvalid={errors.name} mb="24px">
          <Input
            {...register('name', {
              required: 'Este campo é obrigatório',
              minLength: {
                value: 3,
                message: 'O nome deve ter pelo menos 3 caracteres',
              },
            })}
            type="text"
            placeholder="Nome"
          />
          <FormErrorMessage>
            {errors.name && errors.name.message}
          </FormErrorMessage>
        </FormControl>

        <S.Grid gap="24px">
          <FormControl isInvalid={errors.email}>
            <Input
              {...register('email', {
                required: 'Este campo é obrigatório',
                pattern: {
                  value: /\S+@\S+\.\S+/,
                  message: 'Digite um email válido',
                },
              })}
              type="email"
              placeholder="Email"
            />
            <FormErrorMessage>
              {errors.email && errors.email.message}
            </FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={errors.confirmarEmail}>
            <Input
              {...register('confirmarEmail', {
                validate: (value) =>
                  value === getValues('email') || 'Os emails não correspondem',
              })}
              type="email"
              placeholder="Confirme seu email"
            />
            <FormErrorMessage>
              {errors.confirmarEmail && errors.confirmarEmail.message}
            </FormErrorMessage>
          </FormControl>
        </S.Grid>

        <FormControl isInvalid={errors.message} mt="24px">
          <Textarea
            {...register('message', { required: 'Este campo é obrigatório' })}
            placeholder="Mensagem"
            resize="none"
          />
          <FormErrorMessage>
            {errors.message && errors.message.message}
          </FormErrorMessage>
        </FormControl>

        <FormControl mt="24px" isInvalid={!isValid()}>
          <FormLabel>{question}</FormLabel>

          <Input
            type="text"
            placeholder="Digite aqui a resposta"
            onChange={(event) => reply(event.target.value)}
          />
          <FormErrorMessage>
            Por favor, responda a questão acima.
          </FormErrorMessage>
        </FormControl>

        <S.Button shape="rounded" disabled={!isValid() || loading}>
          Enviar comentário <ArrowForwardIcon w={4} h={4} />
        </S.Button>
      </S.Form>
    </S.Comments>
  )
}

export default Container
